import styled from "styled-components";

export const Bubble = styled.div`
  max-width: 75%;
  padding: 10px 14px;
  border-radius: 18px;
  font-size: 0.95rem;
  line-height: 1.4;
  background-color: ${({ isOwn }) => (isOwn ? "#DCF8C6" : "#f1f0f0")};
  align-self: ${({ isOwn }) => (isOwn ? "flex-end" : "flex-start")};
  margin-bottom: 6px;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const Time = styled.div`
  font-size: 0.7rem;
  text-align: right;
  margin-top: 4px;
  opacity: 0.6;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ isOwn }) => (isOwn ? "flex-end" : "flex-start")};
`;

